/* WOKORA v2.3.3 — business page routing + cart account actions (no modal) */
(() => {
  'use strict';
  const body = document.body;
  const accountUrl = body?.dataset.accountUrl || '/account';
  const businessUrl = body?.dataset.businessPageUrl || '/pages/zakelijk-account';
  const businessStatus = body?.dataset.businessStatus || 'guest';

  function enhanceCartAccount() {
    const accountCard = document.querySelector('.w19-flow-account');
    if (!accountCard || accountCard.querySelector('.w233-step-account-actions')) return;

    const oldLink = accountCard.querySelector('.w19-flow-account__link');
    const actions = document.createElement('div');
    actions.className = 'w232-step-account-actions w233-step-account-actions';

    const account = document.createElement('a');
    account.className = businessStatus === 'guest' ? 'button' : 'button button--outline';
    account.href = accountUrl;
    account.textContent = businessStatus === 'guest' ? 'Inloggen / account aanmaken' : 'Mijn account';
    actions.appendChild(account);

    const business = document.createElement('a');
    business.className = businessStatus === 'guest' ? 'button button--outline' : 'button';
    business.href = businessUrl;
    business.textContent = businessStatus === 'approved' ? 'Zakelijke voordelen bekijken' : businessStatus === 'pending' ? 'Aanvraagstatus bekijken' : businessStatus === 'rejected' ? 'Aanvraag aanvullen' : 'Zakelijk account aanvragen';
    actions.appendChild(business);

    if (oldLink) oldLink.insertAdjacentElement('afterend', actions);
    else accountCard.querySelector('.w19-flow-account__status')?.insertAdjacentElement('afterend', actions);

    const points = accountCard.querySelector('.w19-flow-points');
    if (points) {
      points.innerHTML = '<div><b>1</b><span><strong>Postcode controleren</strong><small>Je ziet vooraf of je adres binnen de standaardleverzone valt.</small></span></div><div><b>2</b><span><strong>PO-nummer is optioneel</strong><small>Gebruik een eigen bestelreferentie als je administratie dat nodig heeft.</small></span></div><div><b>3</b><span><strong>Daarna veilig afrekenen</strong><small>Controleer je bestelling en ga vervolgens door naar Shopify Checkout.</small></span></div>';
    }
  }

  function routeLegacyBusinessTrigger(event) {
    const trigger = event.target.closest('[data-w232-open-account-hub], a[href="#wokora-zakelijk"], a[href="#zakelijk-aanvragen"]');
    if (!trigger) return;
    event.preventDefault();
    window.location.href = businessUrl;
  }

  function redirectLegacyHash() {
    if (location.hash === '#wokora-zakelijk' || location.hash === '#zakelijk-aanvragen') window.location.replace(businessUrl);
  }

  document.addEventListener('click', routeLegacyBusinessTrigger);
  function init() { redirectLegacyHash(); enhanceCartAccount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', enhanceCartAccount);
})();
